// メッセージMap
export const MessageMap = {
    "organization_type": "組織タイプ",
    "country_code": "国",
    "organization_name": "組織名",
    "user_name": "ユーザ名",
    "mail_address": "メールアドレス",
    "version_no": "バージョン番号"
};